module.exports = __webpack_public_path__ + "img/trinidad.826b7995.png";